import { render, staticRenderFns } from "./SignupDashboard.vue?vue&type=template&id=28a990b8&scoped=true&"
import script from "./SignupDashboard.vue?vue&type=script&lang=js&"
export * from "./SignupDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SignupDashboard.vue?vue&type=style&index=0&id=28a990b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a990b8",
  null
  
)

component.options.__file = "SignupDashboard.vue"
export default component.exports